import '@scss/styles.scss';

export const shouldUpdateScroll = () => {
  return false;
};
